import { useBed, useBedRequest, useProfile } from '@hook'
import { ActiveTab, Badge, Button, Input, Modal } from '@ui'
import { getError, showToast } from '@util'
import { Box, Spinner, Text } from 'grommet'
import { Search } from 'grommet-icons'
import { useState } from 'react'

type Props = {
  onClose: () => void
  requestId?: string
  modalTitle?: string
}

const tabs = ['all', 'available', 'occupied', 'not_in_service']

export const AssigneBed = ({ onClose, requestId, modalTitle }: Props) => {
  const [tab, setTab] = useState('all')
  const [searchVal, setSearchVal] = useState('')
  const [search, setSearch] = useState(false)
  const { profile } = useProfile({ isLoggedIn: true })
  const facilityId = profile?.relationships?.facility?.data.id

  const { unQueryBeds, unQueryIsLoading } = useBed({ assignStatus: tab, query: searchVal, facility_id: facilityId })
  const { updateRequest } = useBedRequest({})
  const [formId, setFormId] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  const handleAssign = async (id: string) => {
    setIsLoading(true)
    setFormId(id)
    const payload = {
      data: {
        relationships: {
          bed: {
            data: { id, type: 'bed' }
          }
        },
        type: 'bed_request'
      }
    }
    try {
      await updateRequest({ id: requestId as string, payload })
      showToast('Bed assign successful')
      onClose()
    } catch (error) {
      getError(error)
    }
    setIsLoading(false)
  }

  return (
    <Modal onClose={onClose} title={modalTitle || 'Assign Bed'}>
      <Box overflow="auto" pad={{ horizontal: '32px', vertical: '16px' }} style={{ maxHeight: '75vh' }} width={'530px'}>
        <Box border={{ color: '#ddd', side: 'bottom' }} flex={false}>
          <ActiveTab options={tabs} setActive={setTab} tab={tab} />
        </Box>
        <Box margin={{ top: '16px' }}>
          <Input
            handleChange={e => setSearchVal(e.target?.value)}
            icon={<Search color="black" size="small" />}
            onBlur={() => setSearch(false)}
            onFocus={() => setSearch(true)}
            placeholder={'Search....'}
            style={{ backgroundColor: 'white', borderColor: search ? '#A79A46' : '#999999' }}
            value={searchVal}
          />
        </Box>
        <Box overflow="auto">
          {unQueryIsLoading && (
            <Box align="center" alignSelf="center" flex={false} gap="small" justify="center" pad="large">
              <Spinner />
              <Text color="white">Loading...</Text>
            </Box>
          )}
          <Box flex={false} overflow="auto">
            {unQueryBeds?.map(({ attributes, id, meta }) => (
              <Box align="center" direction="row" justify="between" key={id} pad={{ vertical: '20px' }}>
                <Box gap={'6px'}>
                  <div className="inline-flex gap-1 max-w-80 justify-start items-start">
                    <Text color={'#000'}>{attributes.bed_type}</Text>
                    <Badge label={meta.status.replace(/_/g, ' ')} status={meta.status} />
                  </div>
                  <div className="inline-flex items-center gap-1.5">
                    <Text color={'#2D2D2D'} size="12px">
                      {attributes.ref}
                    </Text>
                    <div className="rounded-full w-[3px] aspect-square bg-[#D9D9D9]" />
                    <Text color={'#2D2D2D'} size="12px">
                      Cardiology Unit
                    </Text>
                    <div className="rounded-full w-[3px] aspect-square bg-[#D9D9D9]" />
                    <Text color={'#2D2D2D'} size="12px">
                      {attributes.telemetry ? 'telemetry' : 'non-telemetry'}
                    </Text>
                  </div>
                </Box>
                <Button
                  disabled={meta.status !== 'available' || isLoading === true}
                  isLoading={isLoading === true && id === formId}
                  label="Assign"
                  onClick={() => handleAssign(id)}
                  size={'md'}
                />
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </Modal>
  )
}
